export default __webpack_public_path__ + "static/CircularXXWeb-Medium-056b4626bb3c7b634b6d1aa027d5ff95.woff2";